// extracted by mini-css-extract-plugin
module.exports = {"container":"_2WNZFf1pg53h3oLlke3VsL","sidePanel":"_1S6Uzkuro9m3xACs37EQ14"};